import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	releaseDate: {
		id: 'project-directories.versions.release-version-modal.content.release-date.release-date',
		defaultMessage: 'Release date',
		description: '',
	},
});
